export class DeliveryEdit {
  MethodName: string;
  DeliveryAdressId: number;
}
